import type { ListBuilderConfiguration } from '../types';

/**
 * Group list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const GROUP_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-groups-all',
			cacheTTL: 600000,
			name: 'All Groups',
			type: 'default',
			active: true,
			columns: [
				{
					id: 'group-name',
					fields: [
						{
							id: 'name-field',
							link: {
								type: 'object',
								enabled: true,
								objectTable: 'group',
								idField: '_id',
							},
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'name',
									objectTable: 'group',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h1',
							text: 'Name',
						},
					],
					minWidth: 200,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'name',
							objectTable: 'group',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'large',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'group-type',
					fields: [
						{
							id: 'type-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'type',
									objectTable: 'group',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h1',
							text: 'Type',
						},
					],
					minWidth: 150,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'type',
							objectTable: 'group',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'medium',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'client-count',
					fields: [
						{
							id: 'client-count-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'clientCount',
									objectTable: 'group',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h1',
							text: '# Clients',
						},
					],
					minWidth: 100,
					sortable: true,
					alignment: 'center',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'clientCount',
							objectTable: 'group',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'small',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'item-count',
					fields: [
						{
							id: 'item-count-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'itemCount',
									objectTable: 'group',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h1',
							text: '# Items',
						},
					],
					minWidth: 100,
					sortable: true,
					alignment: 'center',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'itemCount',
							objectTable: 'group',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'small',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'user-count',
					fields: [
						{
							id: 'user-count-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'userCount',
									objectTable: 'group',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h1',
							text: '# Users',
						},
					],
					minWidth: 100,
					sortable: true,
					alignment: 'center',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'userCount',
							objectTable: 'group',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'small',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'auto-add-clients',
					fields: [
						{
							id: 'auto-add-clients-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'shouldAutoAddClients',
									objectTable: 'group',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'boolean',
						},
					],
					headers: [
						{
							id: 'h1',
							text: 'Auto Add Clients',
						},
					],
					minWidth: 120,
					sortable: true,
					alignment: 'center',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'shouldAutoAddClients',
							objectTable: 'group',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'small',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'auto-add-items',
					fields: [
						{
							id: 'auto-add-items-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'shouldAutoAddItems',
									objectTable: 'group',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'boolean',
						},
					],
					headers: [
						{
							id: 'h1',
							text: 'Auto Add Items',
						},
					],
					minWidth: 120,
					sortable: true,
					alignment: 'center',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'shouldAutoAddItems',
							objectTable: 'group',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'small',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'default-for-users',
					fields: [
						{
							id: 'default-for-users-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'isSelectedByDefaultForUsers',
									objectTable: 'group',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'boolean',
						},
					],
					headers: [
						{
							id: 'h1',
							text: 'Default for Users',
						},
					],
					minWidth: 120,
					sortable: true,
					alignment: 'center',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'isSelectedByDefaultForUsers',
							objectTable: 'group',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'small',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'actions',
					headers: [
						{
							id: 'actions-header',
							text: '',
						},
					],
					fields: [
						{
							id: 'actions-dropdown',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'actions_dropdown',
							dropdownActions: [
								{
									id: 'edit-action',
									label: 'Edit',
									iconName: 'pen',
									callbackName: 'editGroup',
									variant: 'primary',
									visibility: 'visible',
									requiredPermission: 'groups:update',
								},
								{
									id: 'delete-action',
									label: 'Delete',
									iconName: 'trash',
									callbackName: 'deleteGroup',
									variant: 'danger',
									visibility: 'visible',
									requiredPermission: 'groups:delete',
								},
							],
						},
					],
					sortable: false,
					width: 80,
					align: 'center',
				},
			],
			searchable: true,
			searchFields: [
				{
					fieldName: 'name',
					objectTable: 'group',
				},
				{
					fieldName: 'type',
					objectTable: 'group',
				},
			],
			defaultSortId: 'column-group-name-asc',
			sortOrder: 0,
		},
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [10, 25, 50, 100],
	},
	filters: {
		activeFilters: [],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/groups/:id',
			objectLabel: 'Group',
			objectTable: 'group',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
				{ fieldName: 'type', fieldLabel: 'Type' },
			],
		},
	],
};
